import Breadcrumb from "../../components/Breadcrumb";
import AgendaLayer from "../../components/agenda/AgendaLayer";

const AgendaPage = () => {
  return (
    <>
      <Breadcrumb title="Agenda" />
      <AgendaLayer />
    </>
  );
};

export default AgendaPage;
